import React from "react";
import { withStyles } from "@material-ui/core";
import { DateTimeEditor } from "@dataGrid/components/cellEditors";
import appConstants from "@appConstants";
import Detail from "./components/Detail";
import { convertDateTimeToTimeString } from "@dataGrid/gridUtilities";

const styles = (theme: any) => ({
  inputRoot: {
    height: 26,
    borderRadius: "4px",
    width: 92,
  },
  labelProps: {
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    width: "max-content",
    top: "-28px",
    "&$shrink": {
      transform: "none",
      top: 0,
    },
  },
  labelFocused: {
    color: `${theme.iconColor} !important`,
    top: 0,
    "&$shrink": {
      transform: "none",
      top: 0,
    },
  },
  filledLabel: {
    top: 4,
    left: 8,
    color: theme.iconColor,
    "&$shrink": {
      transform: "none",
      top: 0,
    },
  },
  shrink: {},
  errorText: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    maxWidth: 80,
  },
});

interface IdealStartTimeEditorProps {
  classes: Record<string, string>;
  value?: string | null;
  error?: boolean;
  helperText?: string | null;
  onChange?: (value: unknown) => void;
}

const IdealStartTimeEditor: React.FC<IdealStartTimeEditorProps> = ({
  classes,
  value,
  error,
  helperText,
  onChange,
}) => (
  <div>
    <DateTimeEditor
      dateType={appConstants.DATETYPES.TIME}
      value={value}
      label="Ideal Start Time"
      InputLabelProps={{
        classes: {
          root: classes.labelProps,
          filled: classes.filledLabel,
          shrink: classes.shrink,
          focused: classes.labelFocused,
        },
      }}
      onChange={onChange}
      disableFocus
      disableFocusInput
      enablePickerPortal
    />
    {!error && helperText && (
      <span className={classes.errorText}>{helperText}</span>
    )}
  </div>
);

const StyledIdealStartTimeEditor = withStyles(styles)(IdealStartTimeEditor);

interface PreDispatchIdealStartTimeEditorProps {
  isEditable: boolean;
  value?: string | null;
  displayValue: string;
  error?: boolean;
  helperText?: string | null;
  onChange?: (value: unknown) => void;
}

/**
 * Renders Ideal Start Time as editable (PreDispatch) or read-only Detail based on condition.
 */
const PreDispatchIdealStartTimeEditor: React.FC<PreDispatchIdealStartTimeEditorProps> = ({
  isEditable,
  value,
  displayValue,
  error,
  helperText,
  onChange,
}) => {
  if (isEditable) {
    const formattedValue = convertDateTimeToTimeString(value);
    return (
      <StyledIdealStartTimeEditor
        value={formattedValue}
        error={error}
        helperText={helperText}
        onChange={onChange}
      />
    );
  }
  return <Detail label="Ideal Start Time" value={typeof displayValue === 'string' ?  displayValue :convertDateTimeToTimeString(displayValue)} inline={true} />;
};

export default PreDispatchIdealStartTimeEditor;
